import React from 'react';
import i18n from 'i18n-js';
import { Box } from '@material-ui/core';
import { BaseModal } from 'components/UI';
import { ReservationDetails } from './ReservationDetails';
import { VehicleDetails } from './VehicleDetails';

export const InvoiceItemDetailsModal = ({ invoiceItem, open, handleCloseModal }) => {
  const type = invoiceItem?.invoice_item_type?.pricing_type?.internal_source_item;
  const description = invoiceItem?.description || invoiceItem?.invoice_item_type?.description;

  const MODAL_TYPES = {
    Vehicle: {
      title: i18n.t('account_statement.Vehicle_modal_title', { description }),
      component: VehicleDetails,
    },
    Reservation: {
      title: i18n.t('account_statement.Reservation_modal_title', { description }),
      component: ReservationDetails,
    },
  };
  const TableDetails = MODAL_TYPES[type].component;
  const title = MODAL_TYPES[type].title;

  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleCloseModal}
      title={title}
    >
      <Box display="flex" flexDirection="column" margin="0 auto">
        <TableDetails invoiceItemId={invoiceItem.id} />
      </Box>
    </BaseModal>
  );
};
